export const StepLifecycleStatuses = {
    AWAITING_SCHEDULING_REQUEST: 'AWAITING_SCHEDULING_REQUEST',
    AWAITING_CANDIDATE_SCHEDULING: 'AWAITING_CANDIDATE_SCHEDULING',
    SCHEDULING_FAILED: 'SCHEDULING_FAILED',
    AWAITING_INTERVIEW: 'AWAITING_INTERVIEW',
    AWAITING_FEEDBACK: 'AWAITING_FEEDBACK',
    AWAITING_DECISION: 'AWAITING_DECISION',
} as const;

export type StepLifecycleStatus =
    (typeof StepLifecycleStatuses)[keyof typeof StepLifecycleStatuses];

export interface LifecycleStatusConfig {
    statusText: string;
    nextAction: string;
    completedActionLabel?: string;
}

export const lifecycleStatusConfig: Record<
    StepLifecycleStatus,
    LifecycleStatusConfig
> = {
    [StepLifecycleStatuses.AWAITING_SCHEDULING_REQUEST]: {
        statusText: 'jobApplicationPage.lifecycle.awaitingSchedulingRequest.status',
        nextAction: 'jobApplicationPage.lifecycle.awaitingSchedulingRequest.nextAction',
    },
    [StepLifecycleStatuses.AWAITING_CANDIDATE_SCHEDULING]: {
        statusText: 'jobApplicationPage.lifecycle.awaitingCandidateScheduling.status',
        nextAction: 'jobApplicationPage.lifecycle.awaitingCandidateScheduling.nextAction',
        completedActionLabel:
            'jobApplicationPage.lifecycle.awaitingCandidateScheduling.completedAction',
    },
    [StepLifecycleStatuses.SCHEDULING_FAILED]: {
        statusText: 'jobApplicationPage.lifecycle.schedulingFailed.status',
        nextAction: 'jobApplicationPage.lifecycle.schedulingFailed.nextAction',
        completedActionLabel:
            'jobApplicationPage.lifecycle.schedulingFailed.completedAction',
    },
    [StepLifecycleStatuses.AWAITING_INTERVIEW]: {
        statusText: 'jobApplicationPage.lifecycle.awaitingInterview.status',
        nextAction: 'jobApplicationPage.lifecycle.awaitingInterview.nextAction',
        completedActionLabel:
            'jobApplicationPage.lifecycle.awaitingInterview.completedAction',
    },
    [StepLifecycleStatuses.AWAITING_FEEDBACK]: {
        statusText: 'jobApplicationPage.lifecycle.awaitingFeedback.status',
        nextAction: 'jobApplicationPage.lifecycle.awaitingFeedback.nextAction',
        completedActionLabel:
            'jobApplicationPage.lifecycle.awaitingFeedback.completedAction',
    },
    [StepLifecycleStatuses.AWAITING_DECISION]: {
        statusText: 'jobApplicationPage.lifecycle.awaitingDecision.status',
        nextAction: 'jobApplicationPage.lifecycle.awaitingDecision.nextAction',
        completedActionLabel:
            'jobApplicationPage.lifecycle.awaitingDecision.completedAction',
    },
};

export const CandidateStatusMenuKeys = {
    SCHEDULE_INTERVIEW: 'scheduleInterview',
    SCHEDULE_CALL: 'scheduleCall',
    SEND_EMAIL: 'sendEmail',
} as const;

export type CandidateStatusMenuKey =
    (typeof CandidateStatusMenuKeys)[keyof typeof CandidateStatusMenuKeys];

export const candidateStatusMenuOptions = [
    {
        key: CandidateStatusMenuKeys.SCHEDULE_INTERVIEW,
        value: 'jobApplicationPage.scheduleInterview',
    },
    {
        key: CandidateStatusMenuKeys.SCHEDULE_CALL,
        value: 'jobApplicationPage.scheduleCall',
        disabled: true,
    },
    {
        key: CandidateStatusMenuKeys.SEND_EMAIL,
        value: 'jobApplicationPage.sendEmail',
    },
];
